import type { ThemePayload } from "../schemas/Theme";
import { Colors } from "./colors";
import { themeTextColor } from "./themeTextColor";

export function isDarkTheme(theme: ThemePayload): boolean {
  return themeTextColor(theme) === Colors.Neutral0;
}
